<template>
  <a-empty
    :image="require('@/assets/images/empty-okr-list.png')"
    :image-style="{
      height: '30%',
    }"
    class="empty-okr-list"
  >
    <a-space
      v-if="canEdit"
      direction="vertical"
      size="large"
    >
      <CreateButton
        icon-name="icontianjia0"
        :text="$t('okr.list.createObjective')"
        :style="{ backgroundColor: '#F8F9FF' }"
        @click="$emit('create-objective')"
      />
      <a-popover trigger="click">
        <template #content>
          <div :style="{ marginBottom: '8px' }">
            {{ $t('guide.okr.create.primary') }}
          </div>
          <img
            :src="$t('guide.okr.create.image')"
            alt="how to create"
            class="create-guide-image"
          >
          <div :style="{ marginTop: '8px' }">
            {{ $t('guide.okr.create.remark') }}
          </div>
        </template>
        <div class="remark1">
          {{ $t('guide.okr.create.remark1') }}
        </div>
        <a-button type="link">
          {{ $t('guide.okr.create.howToCreate') }} >>>
        </a-button>
      </a-popover>
    </a-space>
  </a-empty>
</template>

<script>
import CreateButton from '@/components/CreateButton'

export default {
  components: {
    CreateButton
  },
  props: {
    canEdit: {
      type: Boolean,
      required: true
    }
  },
  emits: [
    'create-objective'
  ]
}
</script>

<style lang="less" scoped>
.empty-okr-list {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: calc(60vh - 120px);
  background: #fff;
  box-shadow: 0 0 6px 0 rgba(39, 52, 125, 0.08);
  border-radius: 8px;
  margin: 0;
  :deep(.ant-space) {
    gap: 12px !important;
  }
}

.create-guide-image {
  width: 840px;
  height: 400px;
}
.remark1 {
  margin-bottom: 8px;
  font-size: 12px;
  color: rgba(0,0,0, 0.56)
}
</style>
